import { isNumber } from 'lodash-es';

import { defaultRatio } from '../../../constants.js';
import { LegendRatio, ChartLegendOrientation } from '../../../types/legend.js';
import { ChartLayoutLegendSizes } from '../types/chart-layout.js';
import { ORIENTATION } from '../types/constants.js';

const isInTheRange = (value: number, min: number, max: number) =>
  value >= min && value <= max;
/**
 * Returns the value of the ratio sanitized.
 * @param legendRatio -
 * @param ratioBoundaries -
 * @param orientation -
 */
export const sanitizeLegendRatio = (
  legendRatio: LegendRatio,
  ratioBoundaries: ChartLayoutLegendSizes,
  orientation: ChartLegendOrientation,
): LegendRatio => {
  if (isNumber(legendRatio)) {
    const isHorizontal = orientation === ORIENTATION.Horizontal;
    const ratioInFraction = legendRatio / 100;

    const min = isHorizontal
      ? ratioBoundaries.minWidth
      : ratioBoundaries.minHeight;
    const max = isHorizontal
      ? ratioBoundaries.maxWidth
      : ratioBoundaries.maxHeight;

    return isInTheRange(ratioInFraction, min, max) ? legendRatio : defaultRatio;
  }
  return defaultRatio;
};
